import React, { useState } from "react";
import { Navbar, UserMenu, NavMenu } from "cubee2e-cube-global-components";
import { ButtonBase } from "@mui/material";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import KeyboardDoubleArrowRightRoundedIcon from "@mui/icons-material/KeyboardDoubleArrowRightRounded";
import KeyboardDoubleArrowLeftRoundedIcon from "@mui/icons-material/KeyboardDoubleArrowLeftRounded";
import CubeLogo from "../../../assets/CubeLogo.svg";
// import { useNavigate } from "react-router-dom";
import { userLogout } from "services/auth-actions";
import { useMsal } from "@azure/msal-react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useAppSelector } from "hooks";
import { appConfig } from "utils/config/appConfig";

const HeaderFirstRow: React.FC = () => {
  const authSelector = useAppSelector((state) => state.auth.auth);
  const [initials] = useState<string>(authSelector?.msName ? authSelector.msName.split(" ")[0].charAt(0) : "");
  const { instance } = useMsal();
  // console.log(NavMenu);

  const navMenuItems = [
    {
      title: "Home",
      logo: CubeLogo,
      logoAltText: "Home",
      navTo: appConfig.redirect_url,
      handleClose: () => {},
    },
  ];
  // const navigate = useNavigate();
  const handleLogout = () => {
    userLogout(instance);
  };
  const navigate = useNavigate();
  const buttonBaseStyles = {
    padding: "1rem",
    "&:hover": {
      backgroundColor: "#303132",
    },
  };
  const location = useLocation();
  const pathSegment = location.pathname.split("/").filter(Boolean);
  const { id } = useParams();
  console.log(id, pathSegment);

  const rightSideComponents = [
    {
      component: (
        <ButtonBase data-testid="bookmarkBorder-icon" sx={buttonBaseStyles} onClick={() => navigate("/")}>
          <HomeOutlinedIcon />
        </ButtonBase>
      ),
    },
    {
      component: (
        <>
          {pathSegment && id ? (
            <ButtonBase
              data-testid="bookmarkBorder-icon"
              sx={buttonBaseStyles}
              onClick={() =>
                navigate(`/${pathSegment[0] === "dataCoreFlow" ? "simEngineFlow" : "dataCoreFlow"}/${id}`, {
                  replace: true,
                })
              }
            >
              {pathSegment[0] === "dataCoreFlow" ? (
                <KeyboardDoubleArrowRightRoundedIcon />
              ) : (
                <KeyboardDoubleArrowLeftRoundedIcon />
              )}
            </ButtonBase>
          ) : null}
        </>
      ),
    },
    {
      title: "userMenu",
      component: (
        <UserMenu
          initials={initials}
          handleLogout={() => {
            handleLogout();
          }}
        />
      ),
    },
    {
      title: "navMenu",
      component: <NavMenu navMenuItems={navMenuItems} />,
    },
  ];

  return (
    <>
      <Navbar
        cubeText="cube"
        initials={initials}
        handleLogout={handleLogout}
        rightComponents={rightSideComponents}
        navMenuItems={navMenuItems}
      />
    </>
  );
};

export default HeaderFirstRow;
